module.exports = __webpack_public_path__ + "static/75invgde-fcde9b20128e33085846817bbf9128b5.gif";